import { connect } from 'react-redux';

import { getBreabcrumbs } from '../../store/breadcrumbs';
import { IApplicationState } from '../../types/redux';

import { BreadCrumbs as BreadCrumbsComponent } from './component';
import { IBreadCrumbsProps } from './types';

export const mapStateToProps = (state: IApplicationState): IBreadCrumbsProps => ({
  breadCrumbs: getBreabcrumbs(state),
});

export const BreadCrumbs = connect(mapStateToProps)(BreadCrumbsComponent);
